<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container modal-container-40" @mousedown="dontClose">
          <div class="modal-body m-0" style="overflow-y: auto;" :style="{maxHeight: getMaxHeightClient() + 'px'}">
            <div slot="formcontent" style="margin: 0px 20px 0px 20px;">
              <b-row>
                <b-col style="text-align:end;">
                  <i class="fa fa-times close-button" style="font-size:20px" @click="handleMouseDown"></i>
                </b-col>
              </b-row>
              <b-row class="panel-heading">
                <b-col cols="12" class="formTitleBlock">
                  <h4 class="content-block labelAccordionForm">
                    <i class="fa-light fa-file-code mr-2" style="font-size: 20px"></i>
                    {{ $t('common.payment_reject') }}
                  </h4>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <input class="commentTextArea border-0 p-0" maxlength="105" isMandatory v-model="reasonLabel" :placeholder="$t('requestToPay.additionnal_inf_rjct')" />
                </b-col>
              </b-row>
            </div>
          </div>
          <div class="modal-footer">
            <b-col cols="6" sm="4" md="3" lg="3" xl="3" class="p-0 m-0">
              <b-button variant="primary"
                @click="rejectPayment">
                {{ $t('common.rvk_label') }}
              </b-button>
            </b-col>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

export default {
  name: 'ChoiceRejectPayment',
  props: {
    data: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      mousedown: false,
      reasonLabel: ''
    }
  },
  created () {
    window.addEventListener('resize', this.changeMaxHeightClient)
    window.addEventListener('mousedown', this.handleMouseDown)
    window.addEventListener('mouseup', this.handleMouseUp)
  },
  destroyed () {
    window.removeEventListener('resize', this.changeMaxHeightClient)
  },
  methods: {
    changeMaxHeightClient () {
      let maxHeight = document.querySelector('body').clientHeight
      document.querySelector('.modal-container').setAttribute('style', 'overflow-y:auto;max-height: maxHeight' + 'px')
    },
    dontClose (e) {
      e.stopPropagation()
    },
    getMaxHeightClient () {
      return document.querySelector('body').clientHeight
    },
    handleMouseDown (e) {
      if (!this.mousedown) {
        if (e.target.closest('.modal-mask') || e.target.closest('.close-button')) {
          this.$emit('close')
        }
        this.mousedown = true
      }
    },
    handleMouseUp (e) {
      this.mousedown = false
    },
    rejectPayment () {
      let adds = 'Payment failed'
      if (this.reasonLabel) {
        adds += ' - ' + this.reasonLabel
      }
      let that = this
      this.$emit('close')
      this.$f7.modal({
        title: that.$i18n.t('common.payment_reject'),
        text: that.$i18n.t('common.action_question'),
        buttons: [{
          text: that.$t('administration.no'),
          onClick: that.$f7.closeModal()
        }, {
          text: that.$t('administration.yes'),
          onClick: function () {
            that.$bus.$emit('answer-to-payments', {
              status: '21',
              optionals: {
                reasonType: 'Code',
                reason: 'NARR',
                additionalInformation: adds
              }
            })
          }
        }]
      })
    }
  }
}

</script>
